<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{name}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="board" slot-scope="board">
          <div>{{board.name}}</div>
        </template>
        <template slot="school_code" slot-scope="school_code">
          <span class="font-weight-bold">{{school_code}}</span>
        </template>
        <template slot="city" slot-scope="city">
          <span>{{city}}</span>
        </template>
        <template slot="phone" slot-scope="phone">
          <span class="font-weight-bold">{{phone.country_code + phone.phone}}</span>
        </template>
        <template slot="status" slot-scope="status">
          <span class="font-weight-bold" :class="status ? 'text-success' : 'text-danger'">{{status ? 'Active' : 'Inactive'}}</span>
        </template>
        <template slot="start_date" slot-scope="start_date">
          <span class="font-weight-bold">{{ handleDate(start_date) }}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a href="javascript:;" class="btn btn-sm btn-primary btn-with-addon mr-2"
              @click="handleManageClick(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-settings" />
              </span>
              <!-- <edit-school ref="editSchool" @edited="handleEdited"/> -->
              Manage
            </a>
            <!-- Edit -->
            <a href="javascript:;" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <!-- <edit-school ref="editSchool" @edited="handleEdited"/> -->
              Edit
            </a>

            <!-- Delete -->
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
              @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </div>

    <edit-school ref="editSchool" @edited="handleEdited"/>
  </div>
</template>
<script>
import moment from 'moment'
import EditSchool from '@/components/school/Forms/Edit/index'

const columns = [
  {
    title: 'School Name',
    dataIndex: 'name',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: 'Board',
    dataIndex: 'board',
    scopedSlots: { customRender: 'board' },
  },
  {
    title: 'School Code',
    dataIndex: 'school_code',
    key: 'school_code',
    scopedSlots: { customRender: 'school_code' },
  },
  {
    title: 'City',
    dataIndex: 'contact.city',
    key: 'contact.city',
    scopedSlots: { customRender: 'city' },
  },
  {
    title: 'Phone No',
    dataIndex: 'contact',
    key: 'contact.phone',
    scopedSlots: { customRender: 'phone' },
  },
  {
    title: 'Start Date',
    dataIndex: 'plan[0].pivot.start_date',
    key: 'plan[0].pivot.start_date',
    scopedSlots: { customRender: 'start_date' },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'SchoolsTable',
  components: {
    EditSchool,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleManageClick: function (record) {
      this.$router.push({ name: 'schoolmanage', params: { id: record.id } })
    },
    showEditModal: function(record) {
      // this.$refs.editSchool.showModal(record.id)
      this.$eventBus.$emit('openEditSchoolModal', record.id)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    handleDate: function($date) {
      return moment($date).format('DD-MM-YYYY')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this board?',
        content: 'Some descriptions',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/school/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
